<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">取得資格</div>
  <div class="card-item-content">
    <div class="input-item"
      v-for="(licence, index) in item.data.licencies"
      :index="index">
      <div class="lisence">
        <Input class="input"
          type="text"
          placeholder="資格名"
          v-model="licence.name" />
        <div class="delete-item">
          <Button @click="destroyLicence(index)" shape="circle" icon="ios-trash-outline"></Button>
        </div>
      </div>
    </div>
    <div class="add-item">
      <Button shape="circle"
        icon="md-add"
        @click="addLicence()"></Button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    addLicence: function () {
      this.$eventHub.$emit(
        'addItem',
        this.groupIndex,
        this.itemIndex,
        'licencies'
      )
    },
    destroyLicence: function (index) {
      this.$eventHub.$emit(
        'destroyItem',
        this.groupIndex,
        this.itemIndex,
        'licencies',
        index
      )
    }
  }
}
</script>
